import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../core';
import API from '../../services/api';
import { INotificacionNews } from '../../services/api/entity/model';
import Alert from '../alerts';
import { AutoComplete, Button, Dialog, Dropdown, InputText, InputTextarea, Menu, OverlayPanel } from '../prime';
import styles from './index.module.scss';
import { fixHtml } from './index.service';
import { UsuarioComboItem } from '../../model/seguridad';

const DiccionaryKey = 'components/notifications';

interface IProps {
  storage?: IDataStorage;

  notificaciones: INotificacionNews[];

  /** orden de actualizar las notificaciones */
  onRefresh?: () => void;
}

interface IState {
  storage?: IDataStorage;

  notificaciones?: INotificacionNews[];
  notificacionSelected?: INotificacionNews;

  modalNew?: {
    prioridad: number;
    destinatario?: UsuarioComboItem;
    destinatario_force?: number;  // forzar un destinatario
    titulo?: string;
    html?: string;

    destinatariosFiltro?: UsuarioComboItem[];
  };
  
  usuarios?: UsuarioComboItem[];
}

class Index extends React.Component<IProps, IState> {
  state : IState = {};
  optionsPanel: OverlayPanel | null = null;

  componentDidMount = () => Index.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p: IProps, s?: IState) => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.notificaciones !== s?.notificaciones) res.notificaciones = p.notificaciones;
    return res;
  }
  
  mark = (notis?: (INotificacionNews | undefined)[], read?: boolean) => {
    this.optionsPanel && this.optionsPanel.hide();
    const ids = notis?.map(p => p?.id ?? -1).filter(p => p > 0) ?? [];
    console.log("mark", read, notis, ids)
    API.ComunicacionController().Notificaciones().markread({ read:!!read, ids })
      .then(() => this.props.onRefresh && this.props.onRefresh());
  }
  delete = (notis?: (INotificacionNews | undefined)[]) => {
    this.optionsPanel && this.optionsPanel.hide();
    const ids = notis?.map(p => p?.id ?? -1).filter(p => p > 0) ?? [];
    API.ComunicacionController().Notificaciones().remove({ ids })
      .then(() => this.props.onRefresh && this.props.onRefresh());
  }

  openNewMsg = () => {
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    this.setState({ modalNew: { prioridad: 2 } }, () => {
      const { usuarios } = this.state;
      if (!usuarios) 
        API.seguridad().usuario().combo({ activos: true }).then(res => {
          if (!res.success || !res.data) Alert.reponse(res, t);
          this.setState({ usuarios: res.data })
        }
      )
    });
  }

  send = () => {
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    const { modalNew } = this.state;
    const user = modalNew?.destinatario_force ?? modalNew?.destinatario?.id;
    if (!!user) {
      API.ComunicacionController().Notificaciones().send({
        toUsers: [ user ],
        toRoles: [ ],
        prioridad: modalNew?.prioridad,
        icon: 'pi pi-envelope',
        titulo: `#${modalNew?.titulo}`,
        html: `#${modalNew?.html}`,
      })
        .then(() => this.setState({ modalNew: undefined }, () => this.props.onRefresh && this.props.onRefresh()))
        .catch(ex => Alert.error(t('@Id#ErrorInesperado'), `${ex}`))
    }
  }

  render() {
    const { notificacionSelected, notificaciones, modalNew } = this.state;
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    
    const isSendable = modalNew && !!modalNew.destinatario && (modalNew.html?.length ?? 0) > 0 && (modalNew.titulo?.length ?? 0) > 0;

    return <>
      <div className={styles["notificaciones-panel"]}>
        <div className={styles["notificaciones-panel-botonera"]}>
          <Button 
            icon="fab fa-telegram-plane" 
            label={t("Btn.New")}
            className={`p-button-sm c-button-new ${styles["notificacion-boton"]}`}
            tooltip={t("Btn.New.Tooltip")} tooltipOptions={{ position: 'bottom' }}
            onClick={() => this.openNewMsg()}
          />
          <Button 
            icon="fas fa-book-reader" 
            label={t("Btn.ReadAll")}
            className={`p-button-sm c-button-secondary ${styles["notificacion-boton"]}`}
            tooltip={t("Btn.ReadAll.Tooltip")} tooltipOptions={{ position: 'bottom' }}
            onClick={e => this.mark(this.state.notificaciones, true)}
          />
        </div>
        {notificaciones?.map(n => {
          const html = t(n.html?.replace(/\n/g, '<br />').replace(/\r/g, '<br />') ?? '', JSON.parse(n.data ?? '{}'));
          const __html = `<p style="margin: 0">${fixHtml(html)}</p>`;

          return <div className={styles["notificaciones-card-content"]}>
            <div className={`${styles["notificaciones-card"]} ${!n.leido && styles["notificaciones-card-unread"]}`} style={{ "--notificacion-color": `var(--notification-color-${n.prioridad})` } as any}>
                <div className={`${styles["notificaciones-header"]}`} onClick={() => !notificacionSelected?.leido && this.mark([n], true)}>
                  <h6>
                    {!!n.icon && <i className={n.icon}></i>}
                    {!!n.leido ? t('Notificacion.Titulo', { titulo: t(n.titulo ?? ''), sender: (n.creaUsu ?? '') }) : <b>{t('Notificacion.Titulo', { titulo: t(n.titulo ?? ''), sender: (n.creaUsu ?? '') })}</b>}
                    {/*n.creausu}
                    {!!n.leido ? t(n.titulo ?? '') : <b>{t(n.titulo ?? '')}</b>*/}
                    <div className={`${styles["notificaciones-header-config"]}`} onClick={e => this.setState({ notificacionSelected: n }, () => this.optionsPanel?.toggle(e, e.target))}>
                      <i className={`pi pi-ellipsis-v`} />
                    </div>
                    <div className={`${styles["notificaciones-header-reply"]}`} onClick={e => this.setState({ notificacionSelected: n, modalNew: { prioridad: n.prioridad ?? 2, titulo: t(n.titulo ?? '').startsWith("RE") ? t(n.titulo ?? '') : `RE: ${t(n.titulo ?? '')}`, html: t('ReplyText', { from: n.creaUsu ?? '', html: t(n.html ?? '', JSON.parse(n.data ?? '{}')) }), destinatario_force: n.idCreaUsu, destinatario: { id:n.idCreaUsu, showKey:n.creaUsu ?? '' } as any } })}>
                      <i className={`fas fa-reply`} />
                    </div>
                  </h6>
                </div>
                <div className={`${styles["notificaciones-desc"]}`}>
                  <div className={`${styles["notificaciones-desc-content"]}`} dangerouslySetInnerHTML={{ __html }}>
                  </div>
                </div>
            </div>
          </div>
        })}
        <OverlayPanel ref={(el) => this.optionsPanel = el} className={styles["options-panel"]} dismissable>
          <Menu model={[
            notificacionSelected && !notificacionSelected?.leido ? { label: t("Action.MarkAsRead"), command: () => this.mark([notificacionSelected], true) } : undefined,
            notificacionSelected && !!notificacionSelected?.leido ? { label: t("Action.MarkAsUnread"), command: () => this.mark([notificacionSelected], false) } : undefined,
            { label: t("Action.Eliminar"), command: () => this.delete([notificacionSelected]) },
          ].filter(p => !!p) as any} />
        </OverlayPanel>
      </div>
      
      {/* Popup de NUEVO */}
      <Dialog 
        modal
        header={<><span className="pi pi-envelope" style={{ marginRight: 8 }} />{t("New.Titulo")}</>}
        style={{width: '50%'}}
        footer={
          <div style={{ fontSize: '.8em', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            <div style={{ width: 50, height: 10, display: 'inline-flex' }} />
            <Button label={t("New.Msg.Cerrar")} className="p-button-secondary c-button-secondary" onClick={() => this.setState({ modalNew: undefined })} tooltip={t("New.Msg.Cerrar.Tooltip")} tooltipOptions={{position:'top'}} />
            <Button label={t("New.Msg.Guardar")} disabled={!isSendable} className="p-button-primary c-button-primary" onClick={() => this.send()} tooltip={t("New.Msg.Guardar.Tooltip")} tooltipOptions={{position:'top'}} />
          </div>
        }
        visible={!!modalNew} 
        dismissableMask
        onHide={() => this.setState({ modalNew: undefined })}
      >
        <div className={styles["panel-new-content"]}>
          <div className={styles["panel-new-field"]}>
            <div className={styles["panel-new-field-label"]}>{t("New.Msg.Prioridad")}</div>
            <div className={styles["panel-new-field-control"]}>
              <Dropdown 
                options={[
                  { k: 1, v: t("@API.Diccionario#Notificacion.Prioridad.1") },
                  { k: 2, v: t("@API.Diccionario#Notificacion.Prioridad.2") },
                  { k: 3, v: t("@API.Diccionario#Notificacion.Prioridad.3") },
                  { k: 4, v: t("@API.Diccionario#Notificacion.Prioridad.4") },
                  { k: 5, v: t("@API.Diccionario#Notificacion.Prioridad.5") },
                ]}
                optionLabel="v"
                optionValue="k"
                value={modalNew?.prioridad}
                style={{ width: '100%' }}
                onChange={e => { if (modalNew) modalNew.prioridad = e.value; this.setState({ modalNew }); }}
              />
            </div>
          </div>
          <div className={styles["panel-new-field"]}>
            <div className={styles["panel-new-field-label"]}>{t("New.Msg.Destinatarios")}</div>
            <div className={styles["panel-new-field-control"]}>
              <AutoComplete
                field="fullname"
                style={{ width: '100%'}}
                itemTemplate={row => <>{`${row.nombre} ${row.apellido} (${row.login})`}</>}
                value={typeof modalNew?.destinatario === 'string' ? modalNew?.destinatario : modalNew?.destinatario?.showKey}
                readOnly={!!modalNew?.destinatario_force}
                suggestions={modalNew?.destinatariosFiltro}
                completeMethod={e => this.suggestions(e.query?.trim() ?? '')}
                onChange={(e) => { 
                  if (modalNew) {
                    modalNew.destinatario = e.value;
                    this.setState({ modalNew });
                  }
                }}
              />
            </div>
          </div>
          <div className={styles["panel-new-field"]}>
            <div className={styles["panel-new-field-label"]}>{t("New.Msg.Titulo")}</div>
            <div className={styles["panel-new-field-control"]}>
              <InputText
                value={modalNew?.titulo}
                onChange={e => { if(modalNew) modalNew.titulo = e.target.value; this.setState({ modalNew }) }}
              />
            </div>
          </div>
          
          <div className={styles["panel-new-field"]}>
            <div className={styles["panel-new-field-label"]}>{t("New.Msg.Html")}</div>
            <div className={styles["panel-new-field-control"]}>
              <InputTextarea
                value={modalNew?.html}
                onChange={e => { if(modalNew) modalNew.html = e.target.value; this.setState({ modalNew }) }}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </>;
  }

  suggestions = (qry:string) => {
    const { modalNew } = this.state;
    if (modalNew) {
      let results : UsuarioComboItem[] = [];
      if (qry !== '') {
        results = [
          ...(this.state.usuarios ?? []).filter(p => 
            `${p.nombre} ${p.apellido}`.toLowerCase().includes(qry.toLowerCase()) ||
            `${p.login}`.toLowerCase().includes(qry.toLowerCase())
          )
        ];
      }

      modalNew.destinatariosFiltro = results;
      this.setState({ modalNew })
    }
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
